module.exports = __webpack_public_path__ + "img/clic.0e2ffda0.svg";